import React from 'react';

import { Toolbox, Status, Country } from 'Types';
import { useGetToolbox } from 'Api/Queries';

type Props = {
  children: React.ReactElement;
};

export type ToolsContextType = {
  countries: Country[] | undefined;
  transportations: Toolbox[] | undefined;
  constraints: Toolbox[] | undefined;
  handlingUnits: Toolbox[] | undefined;
  status: Status[] | undefined;
  reasons: Toolbox[] | undefined;
};

const ToolsContext = React.createContext<ToolsContextType>({
  countries: [],
  transportations: [],
  constraints: [],
  handlingUnits: [],
  status: [],
  reasons: [],
});

const ToolsProvider = ({ children }: Props): React.ReactElement => {
  const { data: toolboxes } = useGetToolbox({
    variables: {
      modes: ['transportation', 'constraints', 'handlingUnit', 'reason'],
    },
  });

  return (
    <ToolsContext.Provider
      value={{
        countries: toolboxes?.toolbox?.countries,
        transportations: toolboxes?.toolbox?.transportations,
        constraints: toolboxes?.toolbox?.constraints,
        handlingUnits: toolboxes?.toolbox?.handlingUnits,
        status: toolboxes?.toolbox?.status,
        reasons: toolboxes?.toolbox?.reasons,
      }}
    >
      {children}
    </ToolsContext.Provider>
  );
};

export { ToolsContext, ToolsProvider };
